import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { environment } from 'src/environments/environment';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'lp-telegram-page',
  templateUrl: 'lp-telegram.component.html',
  styleUrls: ['lp-telegram.component.scss']
})
export class LpTelegramPageComponent implements OnInit, OnDestroy {

  isLoggedIn$ = this.authService.isAuthenticatedSubject$;
  tokenCheck = true;

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private helperService: HelperService,
    private router: Router
  ) {
    if (this.helperService.isBrowser()) {
      this.activatedRoute.queryParams.pipe(take(1)).subscribe(queryParams => {
        const token = queryParams['token'] ? queryParams['token'] : null;
        if (token) {
          localStorage.setItem('connect-token', token);
          if (this.isLoggedIn$.getValue()) {
            this.router.navigate(['/dashboard']);
          } else {
            this.login();
          }
        } else {
          this.tokenCheck = false;
        }
      });
    }
  }

  ngOnInit() {
    this.helperService.hideHeaderFooter$.next(true);
  }

  goTelegram() {
    getWindow().open(environment.telegramChannel, '_blank');
  }

  login() {
    this.authService.login();
  }

  private is64Characters(str) {
    const regexp = /^.{64}$/;
    return regexp.test(str);
  }

  ngOnDestroy(): void {
    this.helperService.hideHeaderFooter$.next(false);
  }

}
